import { BMPrimitives, BMText } from "@traveloka/district-bloom";
import { useEffect, useState } from "react";
import { ScrollView, StyleSheet } from "react-native";

import { useSafeAreaInsets } from "react-native-safe-area-context";
import { ErrorSection } from "../../../../components";
import BMView from "../../../../components/View/BMView";
import { useMobileContentResource } from "../../../../core/resource/MobileResourceProvider";
import { appendTestId, formatMessage } from "../../../../utils";
import { HotelSearchFormResource } from "../types";
import SearchResultItem from "./SearchResultItem";
import { HotelSearchResponseItem } from "./types";

type Props = {
  searchResults: HotelSearchResponseItem[];
  query: string;
  resource: HotelSearchFormResource;
  isError: boolean;
  onCloseDialog: () => void;
  testID?: string;
};

export default function SearchResult(props: Props) {
  const insets = useSafeAreaInsets();

  const { searchResults, query, isError, onCloseDialog, testID } = props;
  const { CorporateHotelSearchForm, CorporateGeneralErrorMessage } =
    useMobileContentResource();
  const [exactSearchIndex, setExactSearchIndex] = useState(-1);
  useEffect(() => {
    if (query && searchResults.length) {
      setExactSearchIndex(
        searchResults.findIndex(
          (item) => item.name.toLocaleLowerCase() === query.toLocaleLowerCase()
        )
      );
    }
  }, [searchResults, query]);

  const hasExactSearch = exactSearchIndex !== -1;

  const otherResults = hasExactSearch
    ? searchResults.filter((_, index) => index !== exactSearchIndex)
    : searchResults;

  return (
    <ScrollView
      contentContainerStyle={[styles.flex1, { paddingBottom: insets.bottom }]}
    >
      <BMView style={styles.container}>
        {!isError ? (
          !!searchResults.length && (
            <>
              {hasExactSearch && (
                <BMView>
                  <SearchResultItem
                    query={query}
                    item={searchResults[exactSearchIndex]}
                    onCloseDialog={onCloseDialog}
                    testID={appendTestId(testID, "exact_search_result")}
                  />
                </BMView>
              )}
              <BMView>
                <BMText
                  style={{
                    marginTop: hasExactSearch ? BMPrimitives.BMSize.xl : 0,
                  }}
                >
                  {formatMessage(CorporateHotelSearchForm.otherResults, {
                    keyword: query,
                  })}
                </BMText>
                <BMView spacing="sm" style={styles.otherResults}>
                  {otherResults.map((result, index) => (
                    <SearchResultItem
                      key={result.id}
                      query={query}
                      item={result}
                      onCloseDialog={onCloseDialog}
                      testID={appendTestId(
                        testID,
                        `search_result_item-${index}`
                      )}
                    />
                  ))}
                </BMView>
              </BMView>
            </>
          )
        ) : (
          <ErrorSection
            type="LARGE"
            title={CorporateGeneralErrorMessage.fullPageTitle}
            caption={CorporateGeneralErrorMessage.fullPageDescription}
          />
        )}
      </BMView>
    </ScrollView>
  );
}

const styles = StyleSheet.create({
  flex1: {
    flex: 1,
  },
  container: {
    flex: 1,
    paddingHorizontal: BMPrimitives.BMSize.lg,
    marginTop: BMPrimitives.BMSize.lg,
  },
  otherResults: {
    marginTop: BMPrimitives.BMSize.md,
  },
});
